import { useEffect } from "react";
import { Helmet } from "react-helmet";

const SEO = ({ title, description, keywords, image }) => {
    useEffect(() => {
        document.title = title;
    }, [title])
    return (
        <Helmet>
            <title>{title ? `${title}` : "My Ace Bazar"}</title>
            <meta name="description" content={description || "Default My Ace Bazar description"} />
            <meta name="keywords" content={keywords || "default, keywords, here"} />

            <meta property="og:title" content={title || "My Ace Bazar"} />
            <meta property="og:description" content={description || "Default My Ace Bazar description"} />
            <meta property="og:image" content={image || "/default-image.jpg"} />

            <meta name="twitter:title" content={title || "My Ace Bazar"} />
            <meta name="twitter:description" content={description || "Default My Ace Bazar description"} />
            <meta name="twitter:image" content={image || "/default-image.jpg"} />

            <meta name="viewport" content="width=device-width, initial-scale=1" />
        </Helmet>
    );
};

export default SEO;
